import { twMerge } from '@/lib/twMerge';
import { useSettings } from '@/hooks/state/useSettings';
export const INITIALS_ICON_SIZE = {
  Small: 'size-8 text-sm leading-8',
  Medium: 'size-10 text-lg leading-10',
  Large: 'fl-size-14/16 fl-text-xl/2xl fl-leading-14/16',
  XLarge: 'fl-size-16/28 fl-text-2xl/4xl fl-leading-16/28'
} as const;
interface InitialsIconProps {
  className?: string;
}
const InitialsIcon = ({
  className
}: InitialsIconProps) => {
  const {
    settings
  } = useSettings();
  const initials = (settings?.user?.first_name?.[0] ?? '') + (settings?.user?.last_name?.[0] ?? '');
  return <div className={twMerge('flex items-center justify-center rounded-full bg-gray-100 font-semibold text-gray-700 dark:bg-gray-800 dark:text-gray-200', className)} data-sentry-component="InitialsIcon" data-sentry-source-file="InitialsIcon.tsx">
      {initials}
    </div>;
};
export default InitialsIcon;